import React from "react";
import SelectedTableData from "./SelectedTableData";
import SelectionsTableData from "./SelectionsTableData";

type Props = {
  HandleNext: () => void;
  HandleBack: () => void;
  ActiveStep: number;
};

function BOM(props: Props) {
  return (
    <>
      <div className="flex flex-wrap justify-center">
        <div className="tabelcontainer flex-auto mt-2 overflow-auto ">
          <SelectionsTableData />
        </div>
      </div>
      <div className="flex flex-wrap justify-center">
        <div className="tabelcontainer flex-auto mt-2 overflow-auto ">
          <SelectedTableData
            HandleNext={props.HandleNext}
            HandleBack={props.HandleBack}
            ActiveStep={props.ActiveStep}
          />
        </div>
      </div>
    </>
  );
}

export default BOM;
